export default __webpack_public_path__ + "static/nav-logo-43b95913e7193fff935900d9d7dd735c.svg";